<huk-header
  [mobilemenu]="false"
  [nobreadcrumb]="true"
  [navtitle]="pageTitle || enumValue.HIG_LOGO_KEY"
  [primarynavlogolink]="primaryNavLogoLink"
></huk-header>
